import styled from 'styled-components';

import { BaseLoading } from '@gbs-monorepo-packages/common';

export const Container = styled.section`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 999999;
`;

export const BaseLoaderContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-10%, -50%);
`;

export const Loading = styled(BaseLoading)`
  height: 3.25rem;
  width: 3.25rem;
`;
